import bridge from 'utils/bridge.js';

class FeedbackButtonBehaviour {
  static id = 'feedback';

  constructor(node) {
    const { policy, country, prompt } = node.dataset;

    node.addEventListener('click', function(event) {
      if (event.target.matches('a')) {
        event.preventDefault();
      }

      bridge.emit('feedback:open', { policy, country, prompt });
    });
  }
}

export default FeedbackButtonBehaviour;
